// ServicesService

import api from './utils/api';

class ServicesService {
  async listService() {
    const result = await api.get('/services');
    return result.data;
  }

  async getModelServices() {
    const { data } = await api.get('/model-service');
    return data;
  }

  async upsertModelService({ serviceId, optionType }) {
    const result = await api.put('/model-service', { serviceId, optionType });
    return result.data;
  }

  async deleteModelService(serviceId) {
    const { data } = await api.delete(`/model-service/${serviceId}`);
    return data;
  }

  async upsertModelServiceBatch(items) {
    const { data } = await api.put('/model-service/batch', {
      items,
    });
    return data;
  }
}

export default new ServicesService();
